import { motion } from "motion/react";
import { TiLocation } from "react-icons/ti";
import { RiGraduationCapFill } from "react-icons/ri";
import { PiBagSimpleFill } from "react-icons/pi";
import { IoEarthSharp } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
const highlights = [
    {
        title:"Tartous, Syria",
        icon:<TiLocation color="red" />
    },
    {
        title:"B.Sc. Communications & IT Engineering",
        icon:<RiGraduationCapFill />
    },
    {
        title:"Frontend Developer",
        icon:<PiBagSimpleFill color="brown"/>
    },
    {
        title:"Arabic / English",
        icon:<IoEarthSharp color="green" />
    },
    {
        title:"Available for Remote Opportunities",
        icon:<FaCheck color="var(--accent)" />
    },
];
export default function About() {
     //mapping
      const highlightItems = highlights.map((item) => (
        <li key={item.title}>
          <span className="check-mark">{item.icon}</span> {item.title}
        </li>
      ));
      return (
        <section id="hero" className="section hero">
          <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1}}
          transition={{ duration: 1.6 ,delay:0.2 }}
          viewport={{once:true}}>
            <h1>About me:</h1>
            <p className="hero-text">
                I'm a frontend web developer passionate about building modern, responsive,
                and user-friendly web applications using React and modern web technologies.
            </p>
            <p className="hero-text">
                I have professional experience developing government service platforms,
                freelance client projects, and interactive business websites. I enjoy
                transforming ideas into clean, scalable, and maintainable interfaces while
                focusing on performance and user experience.
            </p>
           
          </motion.div>
    
          <motion.div className="hero-card"
          initial={{ opacity: 0, translateY: "60px" }}
          whileInView={{ opacity: 1, translateY: 0 }}
           whileHover={{ scale: 1.02}}
          transition={{
            opacity:{
                  duration:1, delay:0.6
              },
              translateY:{
                  duration:1, delay:0.6
              },
              scale:{
                duration:0.2, delay:0
              }
        }}
          viewport={{once:true}}>
            <ul className="hero-card-highlights">
              {highlightItems}
            </ul>    
          </motion.div>
        </section>
      );

}